var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSenha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(-5357 -2876)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(45 1627)",
    fill: "#1d252c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5357 2876)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5400 -4501)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.75 1627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.917,21.724l-.289,2.6a.458.458,0,0,0,.456.509h1.833a.458.458,0,0,0,.456-.509l-.289-2.6a1.813,1.813,0,0,0,.75-1.474,1.833,1.833,0,0,0-3.667,0A1.813,1.813,0,0,0,14.917,21.724ZM16,19.333a.914.914,0,0,1,.4,1.738.459.459,0,0,0-.256.463l.265,2.382H15.6l.265-2.382a.459.459,0,0,0-.256-.463.914.914,0,0,1,.4-1.738Z",
    transform: "translate(-7.75 -6.5)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.292,8.25H18.917V6.417a6.417,6.417,0,1,0-12.833,0V8.25H4.708a.458.458,0,0,0-.458.458V20.167A1.835,1.835,0,0,0,6.083,22H18.917a1.835,1.835,0,0,0,1.833-1.833V8.708A.458.458,0,0,0,20.292,8.25ZM7,6.417a5.5,5.5,0,1,1,11,0V8.25h-.917V6.417a4.583,4.583,0,0,0-9.167,0V8.25H7Zm9.167,0V8.25H8.833V6.417a3.667,3.667,0,1,1,7.333,0Zm3.667,13.75a.918.918,0,0,1-.917.917H6.083a.918.918,0,0,1-.917-.917v-11H19.833Z",
    transform: "translate(-4.25)",
    fill: "#1d252c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenha);
export default __webpack_public_path__ + "static/media/senha.8c456bdf96d795b25e3b75971d0153b3.svg";
export { ForwardRef as ReactComponent };